import { render, staticRenderFns } from "./RecoverPass.vue?vue&type=template&id=df1915d4&scoped=true"
import script from "./RecoverPass.vue?vue&type=script&lang=js"
export * from "./RecoverPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1915d4",
  null
  
)

export default component.exports